const language = {
    'pt': 
        {
            accepted:           'Aprovado',
            accepted_change:    'Aprovado sujeito a alterações',
            access_app:        'Aceder à plataforma',
            add_new:            'Adicionar novo',
            add_trainee:        'Adicionar e notificar',
            add_trainer:        'Adicionar formador(a)',
            add_trainer_error:        'Este formador(a) já foi adicionado(a) a esta formação.',
            applicant_remove:         'Remover candidato',
            attendance_record:  'Registo de presenças',
            attendance_record_label:  'Legenda',
            attendance_record_missed:  'Faltou',
            attendance_record_present:  'Presente',
            attendance_record_soon:  'Sessão por realizar ou sem data definida',
            avaiable:           'Disponível até',
            available_vacancies:    'Nº de vagas disponíveis',
            available_vacancies_placeholder:    'Introduza as vagas disponíveis',
            back:               'Voltar',
            cancel:             'Cancelar',
            candidate_remove:   'Remover candidato(a)',
            candidates:         'Candidatos',
            certificate:        'Certificado',
            certificate_view:   'Ver certificado',
            close:              'Fechar',
            content:            'Cursos',
            content_gest:       'Gestão de formação',
            content_edit:       'Editar curso',
            content_new:        'Novo curso',
            content_list:       'Lista de cursos',
            content_list_2:     'Lista de cursos concluídos',
            choose_option:      'Escolha uma opção',
            date:              'Data',
            dates:              'Datas',
            date_creation:      'Criação',
            date_avaiable:      'Disponível até',
            date_publication:   'Publicação',
            date_begin:         'Data de início',
            date_end:           'Data de Fim',
            date_extension:     'Prorrogação',
            date_registration_begin:  'Data de início de inscrição',
            date_registration_deadline:  'Data limite de inscrição',
            date_last_update:   'Última actualização',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            draft:              'Rascunho',
            doc_choose:         'Carregar ficheiro(s)',
            duplicate_title:       'Duplicar Registo',
            duplicate_text:        'Tem a certeza que pretende continuar?',
            duplicate_confirm:     'Sim',
            duplicate_cancel:      'Não',
            duplicate_error:       'Problema ao duplicar registo!',
            duration:           'Duração (nº de horas)',
            duration_placeholder: 'Introduza o número de horas',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            field_description:  'Descrição/conteúdos programáticos',
            field_name:         'Nome',
            field_name_placeholder:   'Inserir nome',
            field_project_area:     'Área temática',
            field_project_program:  'Programa',
            field_project_domain:   'Dominio',
            field_project_scope:    'Ambito Territorial',
            field_project_fund:     'Fundo',
            field_text:         'Texto',
            field_title:        'Título',
            field_title_placeholder:  'Inserir título',
            field_from:         'De', 
            field_to:           'Para',
            field_subject:      'Assunto',
            field_message:      'Mensagem',
            field_date:         'Data',
            file_attach:        'Attach file',
            file_delete:         'Apagar ficheiro',
            file_remove:        'Remover ficheiro',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            file_view:          'Ver ficheiro',
            files:              'Ficheiro(s)',
            filter_placeholder: 'Procurar',
            final_evaluation:   'Avaliação final',
            financing:          'Financiamento/custo',
            financing_financed: 'Financiada',
            financing_free:      'Gratuita',
            financing_paid:      'Paga',
            flunked:             'Reprovado', 
            formation_date_start: 'Data de Ínicio',
            formation_date_end: 'Data de Fim',
            formation_language:  'Lingua da formação',
            formation_language_pt:  'Português',
            formation_language_en:  'Inglês',
            formation_language_es:  'Espanhol',
            formation_modality:  'Tipo de Modalidade',
            formation_modality_classroom:  'Presencial',
            formation_modality_online:  'À Distância (online)',
            formation_modality_mixed:  'Misto',
            formation_registrations:  'Inscrições',
            formation_registrations_empty:         'Não existem inscrições nesta formação.',
            formation_schedule:  'Tipo de Horário',
            formation_schedule_working_hours: 'Laboral',
            formation_schedule_post_work: 'Pós Laboral',
            formation_schedule_flexible: 'Flexivel',
            formation_value:    'Valor',
            formation_value_placeholder:    'Introduza o valor a cobrar',
            gest:               'Gestão',
            grade:              'Nota',
            hello:              'Olá',
            hours:              'horas',
            id:                 'ID',
            language:            'Língua',
            layout:             'Tipo',
            name:               'Nome',
            materials:           'Materiais',
            materials_info:              'Nesta área poderá consultar todos os materiais didáticos deste módulo disponibilizados pelo formador.',
            materials_evaluation_session_info:              'Nesta área poderá consultar todos os materiais de avaliação desta sessão disponibilizados pelo formador.',
            materials_session_info:              'Nesta área poderá consultar todos os materiais didáticos desta sessão disponibilizados pelo formador.',
            materials_session_info_2:              'Estes materiais ficam disponíveis para o formando a partir da data da sessão.',
            message:            'Mensagem',
            message_view:       'Ver mensagem',
            messages:           'Mensagens',
            messages_list:      'Lista de mensagens',
            messages_new:       'Nova mensagem',
            module:         'Módulo',
            module_add:         'Adicionar módulo',
            module_add_info:         'Para adicionar módulos a esta formação, clique primeiro no botão "Salvar".',
            module_description:     'Descrição',
            module_description_placeholder:            'Inserir descrição do módulo',
            module_evaluation:            'Avaliação',
            module_evaluation_detailed:            'Avaliação detalhada',
            module_evaluation_placeholder:            'Inserir método de avaliação',
            module_evaluations:            'Avaliações',
            module_evaluations_info:              'Nesta área poderá anexar os seus ficheiros de avaliação deste módulo para posterior revisão pelo formador.',
            module_evaluations_input_attachment_message: 'Não pode voltar a anexar ficheiros porque o formador já atribuiu a nota a esta avaliação.',
            module_evaluations_number: 'Nº de Avaliações',
            module_evaluations_number_placeholder:            'Inserir o número de avaliações',
            module_evaluations_soon:            'Avaliação por atribuir',
            module_final_evaluation:            'Avaliação final do módulo',
            module_insert_error: 'Por favor verifique se os campos do nome e descrição estão preenchidos corretamente!',
            module_name:            'Nome',
            module_name_placeholder:            'Inserir nome do módulo',
            module_objectives:            'Objetivos',
            module_objectives_placeholder:            'Inserir objetivos do módulo',
            module_view:            'Ver info',
            modules:            'Módulos',
            modules_evaluation:            'Avaliação dos módulos',
            modules_empty:            'Não existem módulos nesta formação.',
            modules_view:            'Ver módulos',
            multimedia:         'Multimédia',
            no_results:         'Sem registos',
            notice:             'Aviso',
            notice_message:             'Passados 15 dias da data de conclusão do curso, o formando deixa de ter acesso à gestão e visualização dos conteúdos desse curso.',
            image:              'Imagem de destaque',
            images:             'Imagens',
            image_choose:       'Carregar imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            objectives:         'Objetivos',
            page_config:        'Configuração da Página',
            page_parent:        'Parent',
            pages:              'Páginas',
            pdf_documents:      'Documentos PDF',
            principal:          'Principal',
            profile:            'Perfil',
            profile_view:       'Ver perfil',
            published:          'Publicado',
            quitter:            'Desistente',
            regist:             'Inscrição',
            rejected:           'Não aprovado',
            rejected_reason_label:           'Motivo para a não aprovação',
            remove:             'Remover',
            remove_trainer:             'Remover formador(a)',
            schedule:           'Agendar',
            schedule_to:        'Agendado',
            save:               'Salvar',
            select_trainer_placeholder:        'Escolha o formador(a)',
            send:               'Enviar',
            send_title:         'Enviar mensagem',
            send_text:          'Tem a certeza que pretende continuar?',
            send_confirm:       'Sim',
            send_cancel:        'Não',
            send_error:         'Problema enviar mensagem!',
            send_error_subject: 'Preencha o campo do assunto!',
            send_error_message: 'Preencha o campo da mensagem!',
            send_success:       'Mensagem enviada com sucesso!',
            sent:               'Sent',
            seo_config:         'Configuração SEO',
            seo_description:    'Descrição SEO',
            seo_description_placeholder: 'Introduza a descrição SEO',
            seo_keywords:       'Keywords SEO',
            seo_keywords_small: '(separar por virgula)',
            seo_keywords_placeholder: 'Introduza as keywords SEO',
            seo_title:          'Título SEO',
            seo_title_placeholder: 'Introduza o título SEO',
            session:            'sessão',
            session_completed:   'Concluida',
            session_not_completed:   'Não concluida',
            session_open:        'Abrir sessão',
            session_to_start:   'Por iniciar',
            sessions:           'sessões',
            sessions_empty:     'Não existem sessões neste módulo.',
            sessions_gest:      'Gestão de sessões',
            sessions_number:    'Nº de Sessões',
            sessions_placeholder: 'Introduza o número de sessões',
            sessions_view:      'Ver sessões',
            shortcuts:          'Atalhos',
            state_change:       'Alteração de estado',
            state_change_business_sector:    'Setor de atividade',
            state_change_date_empty:    'Sem data definida',
            state_change_doc_id:          'Cartão de Cidadão ou BI + NIF + NISS',
            state_change_doc_certificate: 'Certificado de Habilitações (ou documento equivalente)',
            state_change_doc_iban:          'IBAN (documento bancário com identificação do/a titular)',
            state_change_doc_emprego:          'Declaração da entidade empregadora ou recibo verde do mês anterior ao início da formação ou declaração da Segurança Social',
            state_change_doc_emprego_horario:          'Comprovativo do horário de trabalho diário (declaração da entidade empregadora ou próprio, se empregado por conta própria)',
            state_change_doc_desempregado:          'Apresentação da declaração actualizada do IEFP em como se encontra desempregado há menos de 12 meses ou apresentação de declaração da Seg. Social, acompanhada de declaração do próprio formando, atestando que está à procura de emprego e desde quando',
            state_change_documents:          'Documentos',
            state_change_educational_background: 'Habilitações académicas',
            state_change_employer_entity:    'Entidade patronal',
            state_change_employment_role:    'Função desempenhada',
            state_change_employment_status:  'Situação profissional',
            state_change_empty:       'Não existem alterações de estado do candidato',
            state_change_view:  'Ver detalhes de alteração de estado',
            state_ended:        'Terminado',
            state_open:         'Em curso',   
            state_to_start:      'Por iniciar', 
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_empty:        'Sem registos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_date_begin:   'Início',
            table_date_end:     'Fim',
            table_state:        'Estado',
            table_actions:      'Acções',
            target_audience:    'Destinatários/condições de inscrição',
            target_placeholder: 'Introduza o público alvo', 
            tasks:              'Tarefas',
            tasks_info:              'Nesta área poderá anexar os seus ficheiros de exercícios ou trabalhos deste módulo para posterior revisão pelo formador.',
            tasks_session_info:              'Nesta área poderá anexar os seus ficheiros de exercícios, trabalhos ou avaliações desta sessão para posterior revisão pelo formador.',
            time_end:           'Hora de fim',
            time_start:           'Hora de inicio',
            trainee: 'Formando(a)',
            trainee_added_and_notified: 'Adicionado(a) e notificado(a)',
            trainee_notified: 'Notificado(a)',
            trainee_notify: 'Notificação de formando(a)',
            trainee_notify_button: 'Notificar formando(a)',
            trainee_notify_confirm_text1: 'Vai notificar o(a) formando(a) ',
            trainee_notify_confirm_text2: ' acerca do estado do pedido de inscrição no curso ',
            trainee_notify_confirm_text3: ' para informá-lo(a) do seu registo no curso ',
            trainee_notify_email_text1:      'Serve o presente email para o/a notificar que ao seu pedido de inscrição no curso ',
            trainee_notify_email_text2:      ' foi atribuido o estado: ',
            trainee_notify_email_text3:      'Será contactado(a) em breve com mais informações.',
            trainee_notify_email_text4:      'Qualquer dúvida não hesite em contactar-nos.',
            trainee_notify_email_text5:      'Serve o presente email para o/a notificar que foi efetuado o seu registo no curso ',
            trainee_notify_email_text6:      ' com data de inicio a ',
            trainee_notify_error: 'Problema ao finalizar notificação',
            trainee_notify_error_button: 'Tem que especificar o motivo para a não aprovação da inscrição.</br>Clique no botão <i class="bi bi-pencil fs-4 px-2 text-primary"></i> para realizar essa operação.',
            trainee_notify_success: 'Notificação enviada com sucesso',
            trainee_remove:   'Remover formando(a)',
            trainees: 'Formandos',
            trainees_empty: 'Não existem formandos nesta formação.',
            trainees_empty_2: 'Não existem formandos registados na plataforma.',
            trainer: 'Formador(a)',
            trainer_assign:     'Atribuir formador(a)',
            trainer_grade:     'Nota do formador',
            trainer_notify: 'Notificação de formador(a)',
            trainer_notify_confirm_text1: 'Vai notificar o(a) formador(a) ',
            trainer_notify_confirm_text2: ' informando-o(a) da sua atribuição ao módulo ',
            trainer_notify_confirm_text3: ' do curso ',
            trainer_notify_email_text1:      'Serve o presente email para o/a notificar que lhe foi atribuído o módulo ',
            trainer_notify_email_text2:      ' do curso ',
            trainer_notify_email_text3:      'Será contactado(a) em breve com mais informações.',
            trainer_notify_email_text4:      'Qualquer dúvida não hesite em contactar-nos.',
            trainer_notify_email_text5:      ' com data de inicio a ',
            trainer_notified: 'Notificado(a)',
            trainer_notify_button: 'Notificar formador(a)',
            trainer_notify_error: 'Problema ao finalizar notificação',
            trainer_notify_error_button: 'Não seleccionou nenhum formador para notificar.',
            trainer_notify_success: 'Notificação enviada com sucesso',
            trainer_remove: 'Remover formador(a)',
            trainers: 'Formadores',
            under_review:       'Em análise',
            view:       'Ver',
            with_emphasis:      'Com destaque',         
            without_emphasis:   'Sem destaque',    
        },
    'en':
        {
            accepted:           'Aprovado',
            accepted_change:    'Aprovado sujeito a alterações',
            access_app:        'Access app',
            add_new:            'Add new',
            add_trainee:        'Add and notify',
            add_trainer:        'Addd trainer',
            add_trainer_error:        'This trainer has already been added to this formation.',
            attendance_record:  'Attendance record',
            attendance_record_label:  'Label',
            attendance_record_missed:  'Missed',
            attendance_record_present:  'Attend',
            attendance_record_soon:  'Sessão por realizar ou sem data definida',
            avaiable:           'Available until',
            available_vacancies:    'Nº of available vacancies',
            available_vacancies_placeholder:    'Insert the available vacancies',
            back:               'Back',
            cancel:             'Cancel',
            candidate_remove:  'Remove candidate',
            candidates:         'Candidates',
            certificate:        'Certificate',
            certificate_view:   'View certificado',
            close:              'Close',
            content:            'Formation',
            content_gest:       'Formation gest',
            content_edit:       'Edit course',
            content_new:        'New course',
            content_list:       'Course list',
            content_list_2:      'Lista de cursos concluídos',
            choose_option:      'Choose an option',
            date:               'Date',
            dates:              'Dates',
            date_creation:      'Creation',
            date_avaiable:      'Avaiable until',
            date_publication:   'Publication',
            date_begin:         'Begin date',
            date_end:           'End date',
            date_extension:     'Extension',
            date_registration_begin:  'Registration begin date',
            date_registration_deadline:  'Registration deadline',
            date_last_update:   'Last update',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            draft:              'Draft',
            doc_choose:         'Upload file(s)',
            duplicate_title:       'Duplicate Regist',
            duplicate_text:        'Are you sure you want to continue?',
            duplicate_confirm:     'Yes',
            duplicate_cancel:      'No',
            duplicate_error:       'Problem duplicating element!',
            duration:           'Duration (nº of hours)',
            duration_placeholder: 'Insert the number of hours',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            field_description:  'Description/syllabus',
            field_name:         'Name',
            field_name_placeholder: 'Insert the name',
            field_project_area:     'Thematic Area',
            field_project_program:  'Program',
            field_project_domain:   'Dommain',
            field_project_scope:    'Trritorial Scope',
            field_project_fund:     'Fund',
            field_text:         'Text',
            field_title:        'Title',
            field_title_placeholder:  'Insert title',
            field_from:         'De', 
            field_to:           'Para',
            field_subject:      'Assunto',
            field_message:      'Mensagem',
            field_date:         'Data',
            file_attach:        'Attach file',
            file_delete:         'Delete file',
            file_remove:        'Remover file',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            file_view:          'View file',
            files:              'File(s)',
            filter_placeholder: 'Search',
            final_evaluation:   'Final evaluation',
            financing:          'Financing/cost',
            financing_financed: 'Financed',
            financing_free:      'Free',
            financing_paid:      'Paid',
            flunked:             'Flunked', 
            formation_date_start: 'Start Date',
            formation_date_end: 'End Date',
            formation_language:  'Formation Language',
            formation_language_pt:  'Portuguese',
            formation_language_en:  'English',
            formation_language_es:  'Spanish',
            formation_modality:  'Modality type',
            formation_modality_classroom:  'Classroom',
            formation_modality_online:  'Online',
            formation_modality_mixed:  'Mixed',
            formation_registrations:  'Inscrições',
            formation_registrations_empty:         'There are no registrations in this formation.',
            formation_schedule:  'Schedule type',
            formation_schedule_working_hours: 'Working Hours',
            formation_schedule_post_work: 'Post Work',
            formation_schedule_flexible: 'Flexible',
            formation_value:    'Value',
            formation_value_placeholder:    'Insert charged value',
            gest:               'Gest',
            grade:              'Grade',
            hello:              'Hello',
            hours:              'hours',
            id:                 'ID',
            language:            'Language',
            layout:             'Type',
            name:               'Nome',
            materials:           'Materiais',
            materials_info:              'Nesta área poderá consultar todos os materiais didáticos deste módulo disponibilizados pelo formador.',
            materials_evaluation_session_info:              'Nesta área poderá consultar todos os materiais de avaliação desta sessão disponibilizados pelo formador.',
            materials_session_info:              'Nesta área poderá consultar todos os materiais didáticos desta sessão disponibilizados pelo formador.',
            materials_session_info_2:              'Estes materiais ficam disponíveis para o formando a partir da data da sessão.',
            message:            'Mensagem',
            message_view:       'Ver mensagem',
            messages:           'Mensagens',
            messages_list:      'Lista de mensagens',
            messages_new:       'Nova mensagem',
            module:             'Module',
            module_add:         'Add module',
            module_add_info:         'To add modules to this formation, click first in button "Save".',
            module_description:     'Description',
            module_description_placeholder:            'Insert module description',
            module_evaluation:            'Evaluation',
            module_evaluation_detailed:            'Detailed evalaution',
            module_evaluation_placeholder:            'Insert evaluation method',
            module_evaluations:            'Evaluations',
            module_evaluations_info:              'Nesta área poderá anexar os seus ficheiros de avaliação deste módulo para posterior revisão pelo formador.',
            module_evaluations_input_attachment_message: 'Não pode voltar a anexar ficheiros porque o formador já atribuiu a nota a esta avaliação.',
            module_evaluations_soon:            'Avaliação por atribuir',
            module_final_evaluation:            'Avaliação final do módulo',
            module_insert_error: 'Por favor verifique se os campos do nome e descrição estão preenchidos corretamente!',
            module_name:            'Module name',
            module_name_placeholder:            'Insert module name',
            module_objectives:            'Objectives',
            module_objectives_placeholder:            'Insert module objectives',
            module_view:            'See info',
            modules:            'Modules',
            modules_evaluation:            'Modules evaluation',
            modules_empty:      'There are no modules in this formation.',
            modules_view:       'View modules',
            multimedia:         'Multimedia',
            no_results:         'No results',
            notice:             'Notice',
            notice_message:             'Passados 15 dias da data de conclusão do curso, o formando deixa de ter acesso à gestão e visualização dos conteúdos desse curso.',
            image:              'Highlight image',
            images:             'Images',
            image_choose:       'Upload image',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            objectives:         'Objetivos',
            page_config:        'Page config',
            page_parent:        'Parent',
            pages:              'Pages',
            pdf_documents:      'PDF Documents',
            principal:          'Principal',
            profile:            'Profile',
            profile_view:        'See profile',
            published:          'Publicado',
            quitter:            'Quitter',
            regist:             'Inscrição',
            rejected:           'Não aprovado',
            rejected_reason_label:           'Rejected reason',
            remove:             'Remove',
            remove_trainer:             'Remove trainer',
            save:               'Save',
            schedule:           'Schedule',            
            schedule_to:        'Schedule', 
            select_trainer_placeholder:        'Choose trainer',
            send:               'Send',
            send_title:         'Enviar mensagem',
            send_text:          'Tem a certeza que pretende continuar?',
            send_confirm:       'Sim',
            send_cancel:        'Não',
            send_error:         'Problema enviar mensagem!',
            send_error_subject: 'Preencha o campo do assunto!',
            send_error_message: 'Preencha o campo da mensagem!',
            send_success:       'Mensagem enviada com sucesso!',
            sent:               'Sent',
            seo_config:         'SEO config',
            seo_description:    'SEO description',
            seo_description_placeholder: 'Insert the SEO description',
            seo_keywords:       'SEO keywords',
            seo_keywords_small: '(separate by comma)',
            seo_keywords_placeholder: 'Insert the SEO keywords',
            seo_title:          'SEO title',
            seo_title_placeholder: 'Insert the SEO title',
            session:            'session',
            session_completed:   'Completed',
            session_not_completed:   'Not completed',
            session_open:        'Open session',
            session_to_start:   'To start',
            sessions:           'sessions',
            sessions_empty:     'There are no sessions in this module.',
            sessions_gest:      'Sessions gest',
            sessions_number:    'Nº of Sessions',
            sessions_placeholder: 'Insert the number of sessions',
            sessions_view:      'View sessions',
            shortcuts:          'Shortcuts',
            state_change:       'Alteração de estado',
            state_change_business_sector:    'Setor de atividade',
            state_change_date_empty:    'Sem data definida',
            state_change_doc_id:          'Cartão de Cidadão ou BI + NIF + NISS',
            state_change_doc_certificate: 'Certificado de Habilitações (ou documento equivalente)',
            state_change_doc_iban:          'IBAN (documento bancário com identificação do/a titular)',
            state_change_doc_emprego:          'Declaração da entidade empregadora ou recibo verde do mês anterior ao início da formação ou declaração da Segurança Social',
            state_change_doc_emprego_horario:          'Comprovativo do horário de trabalho diário (declaração da entidade empregadora ou próprio, se empregado por conta própria)',
            state_change_doc_desempregado:          'Apresentação da declaração actualizada do IEFP em como se encontra desempregado há menos de 12 meses ou apresentação de declaração da Seg. Social, acompanhada de declaração do próprio formando, atestando que está à procura de emprego e desde quando',
            state_change_documents:          'Documents',
            state_change_educational_background: 'Habilitações académicas',
            state_change_employer_entity:    'Entidade patronal',
            state_change_employment_role:    'Função desempenhada',
            state_change_employment_status:  'Situação profissional',
            state_change_empty:       'Não existem alterações de estado do candidato',
            state_change_view:  'Ver detalhes de alteração de estado',
            state_ended:        'Ended',
            state_open:         'In progress',  
            state_to_start:     'To start',  
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_empty:        'No records',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_date_begin:   'Begin',
            table_date_end:     'End',
            table_state:        'State',
            table_actions:      'Actions',
            target_audience:    'Target audience/registration conditions',
            target_placeholder: 'Insert the target audicence',
            tasks:              'Tasks',
            tasks_info:              'Nesta área poderá anexar os seus ficheiros de exercícios ou trabalhos deste módulo para posterior revisão pelo formador.',
            tasks_session_info:              'Nesta área poderá anexar os seus ficheiros de exercícios, trabalhos ou avaliações desta sessão para posterior revisão pelo formador.',
            time_end:           'End time',
            time_start:           'Start time',
            trainee:            'Trainee',
            trainee_added_and_notified: 'Added and notified',
            trainee_notified:   'Notified',
            trainee_notify:     'Trainee notification',
            trainee_notify_button: 'Notify trainee',
            trainee_notify_confirm_text1: 'Vai notificar o(a) formando(a) ',
            trainee_notify_confirm_text2: ' acerca do estado do pedido de inscrição no curso ',
            trainee_notify_confirm_text3: ' para informá-lo(a) do seu registo no curso ',
            trainee_notify_email_text1:      'Serve o presente email para o/a notificar que ao seu pedido de inscrição no curso ',
            trainee_notify_email_text2:      ' foi atribuido o estado: ',
            trainee_notify_email_text3:      'Será contactado(a) em breve com mais informações.',
            trainee_notify_email_text4:      'Qualquer dúvida não hesite em contactar-nos.',
            trainee_notify_email_text5:      'Serve o presente email para o/a notificar que foi efetuado o seu registo no curso ',
            trainee_notify_email_text6:      ' com data de inicio a ',
            trainee_notify_error: 'Problem finishing notification',
            trainee_notify_error_button: 'You must specify the reason for not approving the application.</br>Click on the button <i class="bi bi-pencil fs-4 px-2 text-primary"></i> to perform this operation.',
            trainee_notify_success: 'Notification successfully sent.',
            trainee_remove:   'Remove trainee',
            trainees:           'Trainees',
            trainees_empty:     'There are no trainees in this formation.',
            trainees_empty_2:   'There are no trainees registered na plataforma.',
            trainer:           'Trainer',
            trainer_assign:    'Assign trainer',
            trainer_grade:     'Trainer grade',
            trainer_notify:     'Trainer notification',
            trainer_notify_confirm_text1: 'Vai notificar o(a) formador(a) ',
            trainer_notify_confirm_text2: ' informando-o(a) da sua atribuição ao módulo ',
            trainer_notify_confirm_text3: ' do curso ',
            trainer_notify_email_text1:      'Serve o presente email para o/a notificar que lhe foi atribuído o módulo ',
            trainer_notify_email_text2:      ' do curso ',
            trainer_notify_email_text3:      'Será contactado(a) em breve com mais informações.',
            trainer_notify_email_text4:      'Qualquer dúvida não hesite em contactar-nos.',
            trainer_notify_email_text5:      ' com data de inicio a ',
            trainer_notified:   'Notified',
            trainer_notify_button: 'Notify trainer',
            trainer_notify_error: 'Problem finishing notification',
            trainer_notify_error_button: 'You did not select any trainer.',
            trainer_notify_success: 'Notificação enviada com sucesso',
            trainer_remove:     'Remove trainer',
            trainers:           'Trainers',
            under_review:       'Under review',
            view:       'View',
            with_emphasis:      'With emphasis',         
            without_emphasis:   'Without emphasis',
        }
}

module.exports = {
    language
};